import { useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../../components/feature/AdminLayout';

export default function AdminCertificates() {
  const [certificates] = useState([
    {
      id: 'CERT-2024-156',
      studentName: '김학습',
      courseName: '디지털 마케팅 전문가 과정',
      issueDate: '2024-01-20',
      status: 'active',
      isPaid: true,
      downloadCount: 2,
      studentEmail: 'student1@email.com',
      validUntil: '2026-01-20',
      grade: 'A+',
      templateId: 'template-1',
      templateName: '수료증 템플릿',
      category: 'marketing'
    },
    {
      id: 'CERT-2024-155',
      studentName: '이수료',
      courseName: 'AI 활용 비즈니스 전략',
      issueDate: '2024-01-19',
      status: 'active',
      isPaid: false,
      downloadCount: 0,
      studentEmail: 'student2@email.com',
      validUntil: '2026-01-19',
      grade: 'A',
      templateId: 'template-2',
      templateName: '인증서 템플릿',
      category: 'technology'
    },
    {
      id: 'CERT-2024-154',
      studentName: '박완료',
      courseName: '데이터 분석 실무',
      issueDate: '2024-01-18',
      status: 'active',
      isPaid: true,
      downloadCount: 1,
      studentEmail: 'student3@email.com',
      validUntil: '2026-01-18',
      grade: 'B+',
      templateId: 'template-1',
      templateName: '수료증 템플릿',
      category: 'technology'
    },
    {
      id: 'CERT-2024-153',
      studentName: '최교육',
      courseName: '프로젝트 관리 전문가',
      issueDate: '2024-01-17',
      status: 'suspended',
      isPaid: true,
      downloadCount: 3,
      studentEmail: 'student4@email.com',
      validUntil: '2024-01-17',
      grade: 'A+',
      templateId: 'template-3',
      templateName: '전문가 인증서 템플릿',
      category: 'management'
    },
    {
      id: 'CERT-2024-152',
      studentName: '정학습',
      courseName: '클라우드 컴퓨팅 기초',
      issueDate: '2024-01-16',
      status: 'active',
      isPaid: false,
      downloadCount: 0,
      studentEmail: 'student5@email.com',
      validUntil: '2026-01-16',
      grade: 'A',
      templateId: 'template-2',
      templateName: '인증서 템플릿',
      category: 'technology'
    },
    {
      id: 'CERT-2024-151',
      studentName: '한수료',
      courseName: 'UI/UX 디자인 과정',
      issueDate: '2024-01-15',
      status: 'active',
      isPaid: true,
      downloadCount: 1,
      studentEmail: 'student6@email.com',
      validUntil: '2026-01-15',
      grade: 'A',
      templateId: 'template-1',
      templateName: '수료증 템플릿',
      category: 'design'
    },
    {
      id: 'CERT-2024-150',
      studentName: '조완성',
      courseName: '웹 개발 기초',
      issueDate: '2024-01-14',
      status: 'expired',
      isPaid: false,
      downloadCount: 0,
      studentEmail: 'student7@email.com',
      validUntil: '2026-01-14',
      grade: 'B+',
      templateId: 'template-2',
      templateName: '인증서 템플릿',
      category: 'technology'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [paymentFilter, setPaymentFilter] = useState('all');
  const [templateFilter, setTemplateFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [selectedCertificates, setSelectedCertificates] = useState<string[]>([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState<any>(null);
  const [showBulkDownloadModal, setShowBulkDownloadModal] = useState(false);
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [suspendCertificateId, setSuspendCertificateId] = useState<string | null>(null);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  // 템플릿 목록
  const templates = [
    { id: 'template-1', name: '수료증 템플릿' },
    { id: 'template-2', name: '인증서 템플릿' },
    { id: 'template-3', name: '전문가 인증서 템플릿' }
  ];

  // 카테고리 목록 (관리자가 수정 가능)
  const [categories, setCategories] = useState([
    { id: 'marketing', name: '마케팅' },
    { id: 'technology', name: '기술/IT' },
    { id: 'management', name: '경영/관리' },
    { id: 'design', name: '디자인' }
  ]);

  const [newCategory, setNewCategory] = useState({ name: '' });

  const filteredCertificates = certificates.filter(cert => {
    const matchesSearch = cert.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         cert.courseName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         cert.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || cert.status === statusFilter;
    const matchesPayment = paymentFilter === 'all' || 
                          (paymentFilter === 'paid' && cert.isPaid) ||
                          (paymentFilter === 'free' && !cert.isPaid);
    const matchesTemplate = templateFilter === 'all' || cert.templateId === templateFilter;
    const matchesCategory = categoryFilter === 'all' || cert.category === categoryFilter;
    
    return matchesSearch && matchesStatus && matchesPayment && matchesTemplate && matchesCategory;
  });

  // 페이지네이션 계산
  const totalPages = Math.ceil(filteredCertificates.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentCertificates = filteredCertificates.slice(startIndex, endIndex);

  // 페이지 번호 배열 생성 (최대 15페이지까지 표시)
  const getPageNumbers = () => {
    const maxVisiblePages = 15;
    const pages: (number | string)[] = [];
    
    if (totalPages <= maxVisiblePages) {
      // 전체 페이지가 15개 이하면 모두 표시
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // 15개 초과시 현재 페이지 기준으로 표시
      const halfVisible = Math.floor(maxVisiblePages / 2);
      let startPage = Math.max(1, currentPage - halfVisible);
      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      
      if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
      
      if (startPage > 1) {
        pages.push(1);
        if (startPage > 2) pages.push('...');
      }
      
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSelectedCertificates([]);
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedCertificates(currentCertificates.map(cert => cert.id));
    } else {
      setSelectedCertificates([]);
    }
  };

  const handleSelectCertificate = (certId: string, checked: boolean) => {
    if (checked) {
      setSelectedCertificates([...selectedCertificates, certId]);
    } else {
      setSelectedCertificates(selectedCertificates.filter(id => id !== certId));
    }
  };

  const handleBulkAction = (action: string) => {
    if (selectedCertificates.length === 0) {
      alert('선택된 증명서가 없습니다.');
      return;
    }
    
    switch (action) {
      case 'download':
        // 50개 제한 확인
        if (selectedCertificates.length > 50) {
          alert('한 번에 최대 50개까지만 다운로드할 수 있습니다.\n현재 선택: ' + selectedCertificates.length + '개');
          return;
        }
        
        // 월간 일괄 다운로드 횟수 제한 확인
        if (bulkDownloadCount > downloadLimit) {
          setShowUpgradeModal(true);
          return;
        }
        
        setShowBulkDownloadModal(true);
        break;
      case 'suspend':
        if (confirm(`선택된 ${selectedCertificates.length}개 증명서를 일시정지하시겠습니까?`)) {
          alert(`선택된 ${selectedCertificates.length}개 증명서가 일시정지되었습니다.`);
          setSelectedCertificates([]);
        }
        break;
      case 'delete':
        if (confirm(`선택된 ${selectedCertificates.length}개 증명서를 삭제하시겠습니까?`)) {
          alert('증명서가 삭제되었습니다.');
          setSelectedCertificates([]);
        }
        break;
    }
  };

  const handleBulkDownload = (format: 'excel' | 'pdf') => {
    const count = selectedCertificates.length;
    const limit = format === 'excel' ? 1000 : 100;
    
    if (count > limit) {
      alert(`${format.toUpperCase()} 다운로드는 최대 ${limit}개까지 가능합니다. 현재 선택: ${count}개`);
      return;
    }
    
    alert(`선택된 ${count}개 증명서를 ${format.toUpperCase()} 파일로 다운로드합니다.`);
    setBulkDownloadCount(prev => prev + 1);
    setShowBulkDownloadModal(false);
    setSelectedCertificates([]);
  };

  const handleViewDetail = (cert: any) => {
    setSelectedCertificate(cert);
    setShowDetailModal(true);
  };

  const handleSuspendCertificate = (certId: string) => {
    setSuspendCertificateId(certId);
    setShowSuspendModal(true);
  };

  const confirmSuspend = () => {
    if (suspendCertificateId) {
      alert('증명서가 일시정지되었습니다.');
      setShowSuspendModal(false);
      setSuspendCertificateId(null);
    }
  };

  const addCategory = () => {
    if (!newCategory.name.trim()) return;
    
    const categoryId = newCategory.name.toLowerCase().replace(/\s+/g, '-');
    const category = {
      id: categoryId,
      name: newCategory.name
    };
    
    setCategories([...categories, category]);
    setNewCategory({ name: '' });
    alert('카테고리가 추가되었습니다.');
  };

  const deleteCategory = (categoryId: string) => {
    if (confirm('이 카테고리를 삭제하시겠습니까?')) {
      setCategories(categories.filter(cat => cat.id !== categoryId));
      alert('카테고리가 삭제되었습니다.');
    }
  };

  const resetFilters = () => {
    setSearchTerm('');
    setStatusFilter('all');
    setPaymentFilter('all');
    setTemplateFilter('all');
    setCategoryFilter('all');
    setCurrentPage(1);
  };

  const [downloadCount, setDownloadCount] = useState(45); // 현재 월 다운로드 횟수
  const [bulkDownloadCount, setBulkDownloadCount] = useState(1); // 일괄 다운로드 사용 횟수
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [notification, setNotification] = useState<{show: boolean; message: string; type: 'success' | 'error'}>({
    show: false,
    message: '',
    type: 'success'
  });

  // 플랜별 다운로드 제한
  const downloadLimits: Record<string, number> = {
    'Free': 1,
    'Basic': 10,
    'Pro': 100,
    'Enterprise': Infinity
  };

  const currentPlan = 'Pro'; // 현재 플랜
  const downloadLimit = downloadLimits[currentPlan];

  const handleDownload = (certificate: any) => {
    // 개별 다운로드는 횟수 제한 없음
    try {
      const fileName = `증명서_${certificate.studentName}_${certificate.issueDate.replace(/\./g, '')}.pdf`;
      
      setNotification({
        show: true,
        message: `${certificate.studentName}님의 증명서가 다운로드되었습니다.`,
        type: 'success'
      });

      setTimeout(() => {
        setNotification({ show: false, message: '', type: 'success' });
      }, 3000);

    } catch (error) {
      setNotification({
        show: true,
        message: '다운로드 중 오류가 발생했습니다.',
        type: 'error'
      });

      setTimeout(() => {
        setNotification({ show: false, message: '', type: 'success' });
      }, 3000);
    }
  };

  return (
    <AdminLayout>
      {/* 알림 메시지 */}
      {notification.show && (
        <div className={`fixed top-4 right-4 z-50 px-6 py-4 rounded-lg shadow-lg ${
          notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'
        } text-white flex items-center gap-3`}>
          <i className={`${notification.type === 'success' ? 'ri-check-line' : 'ri-error-warning-line'} text-xl`}></i>
          <span>{notification.message}</span>
        </div>
      )}

      {/* 업그레이드 모달 */}
      {showUpgradeModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-error-warning-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">일괄 다운로드 제한 초과</h3>
              <p className="text-gray-600">
                {currentPlan} 플랜의 월간 일괄 다운로드 제한({downloadLimit}회)에 도달했습니다.
              </p>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-gray-600">이번 달 사용량</span>
                <span className="text-sm font-semibold text-gray-900">{bulkDownloadCount} / {downloadLimit}회</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-orange-500 h-2 rounded-full transition-all"
                  style={{ width: `${(bulkDownloadCount / downloadLimit) * 100}%` }}
                ></div>
              </div>
            </div>

            <p className="text-sm text-gray-600 mb-6 text-center">
              더 많은 일괄 다운로드가 필요하시면 플랜을 업그레이드해주세요.
            </p>

            <div className="flex gap-3">
              <button
                onClick={() => setShowUpgradeModal(false)}
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                닫기
              </button>
              <button
                onClick={() => {
                  setShowUpgradeModal(false);
                  window.REACT_APP_NAVIGATE('/admin/settings');
                }}
                className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                플랜 업그레이드
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="p-6">
        {/* 헤더 */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">증명서 관리</h1>
            <p className="text-sm text-gray-500">발급된 증명서를 조회하고 관리하세요</p>
          </div>
          <div className="flex space-x-3">
            <button
              onClick={() => setShowCategoryModal(true)}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-folder-add-line mr-2"></i>
              카테고리 관리
            </button>
            <button
              onClick={() => handleBulkAction('download')}
              disabled={selectedCertificates.length === 0}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              <i className="ri-download-line mr-2"></i>
              일괄 다운로드 ({bulkDownloadCount}/{downloadLimit === Infinity ? '∞' : downloadLimit})
            </button>
          </div>
        </div>

        {/* 필터 및 검색 */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">검색</label>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="학습자명, 과정명, 증명서 ID"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">템플릿</label>
              <select
                value={templateFilter}
                onChange={(e) => setTemplateFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
              >
                <option value="all">전체 템플릿</option>
                {templates.map(template => (
                  <option key={template.id} value={template.id}>{template.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">카테고리</label>
              <select
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
              >
                <option value="all">전체 카테고리</option>
                {categories.map(category => (
                  <option key={category.id} value={category.id}>{category.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">상태</label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
              >
                <option value="all">전체</option>
                <option value="active">활성</option>
                <option value="suspended">일시정지</option>
                <option value="expired">만료</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">결제 유형</label>
              <select
                value={paymentFilter}
                onChange={(e) => setPaymentFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
              >
                <option value="all">전체</option>
                <option value="paid">유료</option>
                <option value="free">무료</option>
              </select>
            </div>
            <div className="flex items-end">
              <button
                onClick={resetFilters}
                className="w-full border border-gray-300 text-gray-700 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-refresh-line mr-1"></i>
                초기화
              </button>
            </div>
          </div>
        </div>

        {/* 통계 요약 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-file-text-line text-blue-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">총 증명서</p>
                <p className="text-xl font-semibold text-gray-900">{filteredCertificates.length}</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-check-line text-green-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">활성 증명서</p>
                <p className="text-xl font-semibold text-gray-900">
                  {filteredCertificates.filter(cert => cert.status === 'active').length}
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-money-dollar-circle-line text-purple-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">유료 증명서</p>
                <p className="text-xl font-semibold text-gray-900">
                  {filteredCertificates.filter(cert => cert.isPaid).length}
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-calendar-line text-orange-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">이번 달 발급</p>
                <p className="text-xl font-semibold text-gray-900">
                  {filteredCertificates.filter(cert => cert.issueDate.startsWith('2024-01')).length}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 일괄 작업 */}
        {selectedCertificates.length > 0 && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between">
              <span className="text-blue-800 font-medium">
                {selectedCertificates.length}개 증명서가 선택되었습니다
                {selectedCertificates.length > 50 && (
                  <span className="ml-2 text-red-600 text-sm">
                    (최대 50개까지 일괄 다운로드 가능)
                  </span>
                )}
              </span>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleBulkAction('suspend')}
                  className="bg-orange-600 text-white px-3 py-1.5 text-sm rounded hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-pause-circle-line mr-1"></i>
                  일시정지
                </button>
                <button
                  onClick={() => handleBulkAction('delete')}
                  className="bg-red-600 text-white px-3 py-1.5 text-sm rounded hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-delete-bin-line mr-1"></i>
                  삭제
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 증명서 테이블 */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">
                    <input
                      type="checkbox"
                      checked={selectedCertificates.length === currentCertificates.length && currentCertificates.length > 0}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">증명서 ID</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">학습자명</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">과정명</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">템플릿</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">카테고리</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">발급일</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">만료일</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">액션</th>
                </tr>
              </thead>
              <tbody>
                {currentCertificates.map((cert) => (
                  <tr key={cert.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-4 px-4">
                      <input
                        type="checkbox"
                        checked={selectedCertificates.includes(cert.id)}
                        onChange={(e) => handleSelectCertificate(cert.id, e.target.checked)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                    </td>
                    <td className="py-4 px-4 font-mono text-sm text-blue-600">{cert.id}</td>
                    <td className="py-4 px-4 font-medium text-gray-900">{cert.studentName}</td>
                    <td className="py-4 px-4 text-gray-700">{cert.courseName}</td>
                    <td className="py-4 px-4">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                        {cert.templateName}
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800">
                        {categories.find(cat => cat.id === cert.category)?.name}
                      </span>
                    </td>
                    <td className="py-4 px-4 text-gray-600">{cert.issueDate}</td>
                    <td className="py-4 px-4 text-gray-600">{cert.validUntil || '-'}</td>
                    <td className="py-4 px-4">
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleViewDetail(cert)}
                          className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                        >
                          <i className="ri-eye-line"></i>
                        </button>
                        <button 
                          onClick={() => handleDownload(cert)}
                          className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-green-600 transition-colors cursor-pointer"
                          title="다운로드"
                        >
                          <i className="ri-download-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredCertificates.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-file-text-line text-4xl text-gray-300 mb-4"></i>
              <p className="text-gray-500">조건에 맞는 증명서가 없습니다.</p>
            </div>
          )}
        </div>

        {/* 페이지네이션 */}
        {totalPages > 1 && (
          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm text-gray-600">
              전체 {filteredCertificates.length}개 중 {startIndex + 1}-{Math.min(endIndex, filteredCertificates.length)}개 표시
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="w-8 h-8 flex items-center justify-center rounded border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              
              {getPageNumbers().map((page, index) => (
                <button
                  key={index}
                  onClick={() => typeof page === 'number' && handlePageChange(page)}
                  disabled={page === '...'}
                  className={`min-w-[32px] h-8 px-2 flex items-center justify-center rounded text-sm font-medium transition-colors cursor-pointer ${
                    page === currentPage
                      ? 'bg-blue-600 text-white'
                      : page === '...'
                      ? 'text-gray-400 cursor-default'
                      : 'border border-gray-300 text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {page}
                </button>
              ))}
              
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="w-8 h-8 flex items-center justify-center rounded border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        )}

        {/* 카테고리 관리 모달 */}
        {showCategoryModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-md w-full">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">카테고리 관리</h2>
                    <p className="text-gray-600">증명서 카테고리를 추가하거나 삭제할 수 있습니다</p>
                  </div>
                  <button
                    onClick={() => setShowCategoryModal(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">새 카테고리 추가</label>
                    <div className="flex space-x-2">
                      <input
                        type="text"
                        value={newCategory.name}
                        onChange={(e) => setNewCategory({ name: e.target.value })}
                        placeholder="카테고리 이름"
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <button
                        onClick={addCategory}
                        disabled={!newCategory.name.trim()}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
                      >
                        추가
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">기존 카테고리</label>
                    <div className="space-y-2 max-h-64 overflow-y-auto">
                      {categories.map((category) => (
                        <div key={category.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                          <span className="font-medium text-gray-900">{category.name}</span>
                          <button
                            onClick={() => deleteCategory(category.id)}
                            className="text-red-600 hover:text-red-800 transition-colors cursor-pointer"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    onClick={() => setShowCategoryModal(false)}
                    className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    완료
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 일시정지 확인 모달 */}
        {showSuspendModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-md w-full">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-pause-circle-line text-2xl text-orange-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900">증명서 일시정지</h2>
                    <p className="text-gray-600">이 증명서를 일시정지하시겠습니까?</p>
                  </div>
                </div>

                <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
                  <h4 className="font-medium text-orange-900 mb-2">일시정지 시 영향</h4>
                  <div className="text-sm text-orange-800 space-y-1">
                    <p>• 증명서 다운로드가 차단됩니다</p>
                    <p>• 공개 검증이 불가능해집니다</p>
                    <p>• 학습자에게 알림이 발송됩니다</p>
                    <p>• 언제든지 다시 활성화할 수 있습니다</p>
                  </div>
                </div>

                <div className="flex space-x-3">
                  <button
                    onClick={() => setShowSuspendModal(false)}
                    className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    취소
                  </button>
                  <button
                    onClick={confirmSuspend}
                    className="flex-1 bg-orange-600 text-white py-2 px-4 rounded-lg hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    일시정지
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 상세 정보 모달 */}
        {showDetailModal && selectedCertificate && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">증명서 상세 정보</h2>
                    <p className="text-gray-600">증명서 ID: {selectedCertificate.id}</p>
                  </div>
                  <button
                    onClick={() => setShowDetailModal(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">학습자 정보</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">이름:</span>
                        <span className="font-medium">{selectedCertificate.studentName}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">이메일:</span>
                        <span className="font-medium">{selectedCertificate.studentEmail}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">성적:</span>
                        <span className="font-medium text-green-600">{selectedCertificate.grade}</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">증명서 정보</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">과정명:</span>
                        <span className="font-medium">{selectedCertificate.courseName}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">템플릿:</span>
                        <span className="font-medium">{selectedCertificate.templateName}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">카테고리:</span>
                        <span className="font-medium">
                          {categories.find(cat => cat.id === selectedCertificate.category)?.name}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">발급일:</span>
                        <span className="font-medium">{selectedCertificate.issueDate}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">유효기간:</span>
                        <span className="font-medium">{selectedCertificate.validUntil}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">다운로드:</span>
                        <span className="font-medium">{selectedCertificate.downloadCount}회</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex space-x-3 mt-6 pt-6 border-t border-gray-200">
                  <button className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-download-line mr-2"></i>
                    PDF 다운로드
                  </button>
                  <button className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-mail-line mr-2"></i>
                    이메일 발송
                  </button>
                  <button className="flex-1 border border-red-300 text-red-600 py-2 px-4 rounded-lg hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-pause-circle-line mr-2"></i>
                    일시정지
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
